import React, { useState } from "react";
import { Tabs, theme } from "antd";
import { PRODUCT_TYPE, USER_GROUP } from "../constants/string";
import { useUserContext } from "../hooks/UserSettingProvider";
import ProducePreorderList from "../components/sale-list/ProducePreorderList";

export default function ProducePreorderView() {
  const tableRef = React.useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useUserContext();
  const hasPermission = (target) => (user && user.groups &&  user.groups.length > 0 ? user.groups.find((group) => group === target) : true)

  const items = [
    {
      key: "latexproducelist",
      label: "ใบแจ้งผลิตน้ำยางข้น",
      children: <ProducePreorderList type={PRODUCT_TYPE.CONCENTRATE_LATEX}/>,
      permission : true,
    },
    {
      key: "skimproducelist",
      label: "ใบแจ้งผลิตสกิม",
      children: <ProducePreorderList type={PRODUCT_TYPE.SKIM}/>,
      permission : true,
    },
  ];

  return (
    <div style={{ marginTop: 20 }}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="latexsaleslist"
        items={items.filter((item) => item.permission == true)}
        style={{ marginTop: 15 }}
      />
      {isLoading && (
        <p style={{ textAlign: "center", color: "gray" }}>กำลังโหลดข้อมูล...</p>
      )}
    </div>
  );
}
